<template>
  <div class="list-page-header">
    <h3 class="title">{{ $t("survey.manager_survey") }}</h3>
    <md-button
      v-if="canAdd"
      class="md-success btn-search ml-6"
      @click="go2AddPage"
    >
      {{ $t("common.add_new") }}
    </md-button>
  </div>
</template>

<script>
import { survey_router_names } from "@/routes/routes";
import { Survey } from "@/constants/Permissions";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import { mapGetters } from "vuex";
export default {
  name: "ListPageHeader",
  computed: {
    ...mapGetters("user", {
      userRole: "role"
    }),
    canAdd() {
      return (
        this.$can(Survey.actions.add, Survey.subject) ||
        hasValidRole(this.userRole, Role.Teacher)
      );
    }
  },
  methods: {
    go2AddPage() {
      this.$router.push({ name: survey_router_names.addPage });
    }
  }
};
</script>
